import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ConnectionState } from "../states/connection.state";

export const selectConnectionsState =
  createFeatureSelector<ConnectionState>("connection");

export const selectConnections = createSelector(
  selectConnectionsState,
  (state) => state.connection
);

export const selectConnectionLoading = createSelector(
  selectConnectionsState,
  (state) => state.loading
);

export const selectConnectionError = createSelector(
  selectConnectionsState,
  (state) => state.error
);

export const selectJiraConnections = createSelector(
  selectConnectionsState,
  (state) => state.connection?.ALM
);

export const selectLlmConnections = createSelector(
  selectConnectionsState,
  (state) => state.connection?.LLM
);

export const selectFileConnections = createSelector(
  selectConnectionsState,
  (state) => state.connection?.FILE
);
